import React, { PureComponent } from 'react'

import { toArray, get } from 'lodash'
import { Select, Avatar, Icon } from "@driftt/tide-core-legacy"
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import { PARTICIPANT_TYPES } from './constants'

const UserAvatarOption = ({ user, onUserDeleted }) => {
  const nameOrEmail = user ? (user.name ? user.name : user.email) : 'Unknown User'

  return (
    <div className="choice-dropdown-option">
      <Avatar user={user} />
      <span className="choice-option-value">{nameOrEmail}</span>
      { onUserDeleted &&
        <div className="choice-delete-icon" onClick={() => onUserDeleted(user)}>
          <Icon name="close" height={10} width={10}/>
        </div>
      }
    </div>
  )
}


class GroupParticipantAction extends PureComponent {

  constructor(props) {
    super(props)

    const selectedParticipants = get(props.rule, 'data.item.action.options.userIds', [])
    const availableUsersReducer = (usersArray, user) => {
      if (!selectedParticipants.includes(user.id)) {
        usersArray.push({
          label: getDisplayName(user),
          value: Number(user.id)
        })
      }

      return usersArray
    }

    this.state = {
      selectedParticipants,
      availableUsers: toArray(this.props.users)
                        .reduce(availableUsersReducer, [])
    }
  }

  renderSelectOption = ({ value }) => {
    const { users } = this.props

    return <UserAvatarOption user={users[value]}/>
  }

  onParticipantsSelected = (selectedOption) => {
    const { setActionParticipants } = this.props

    this.setState((prevState) => {
      const selectedOptions = [...prevState.selectedParticipants, selectedOption[0].value]
      const availableUsers = prevState.availableUsers.filter(user => user.value !== selectedOption[0].value)

      return {
        selectedParticipants: selectedOptions,
        availableUsers
      }
    },
    () => {
      setActionParticipants({
        participants: this.state.selectedParticipants,
        participantType: PARTICIPANT_TYPES.GROUP
      })
    })
  }

  onGroupUserRemoved = (user) => {
    const { setActionParticipants } = this.props

    this.setState((prevState) => {
      const groupUsers = [...prevState.selectedParticipants].filter(participantId => participantId !== user.id)

      return {
        selectedParticipants: groupUsers,
        availableUsers: prevState.availableUsers.filter(availableUser => availableUser.value !== user.id)
      }
    },
    () => {
      setActionParticipants({
        participants: this.state.selectedParticipants,
        participantType: PARTICIPANT_TYPES.GROUP
      })
    })
  }

  render() {
    const { users } = this.props
    const { selectedParticipants, availableUsers } = this.state

    return (
      <div className="participant-action single-participant">
        <div className="participant-action-selector-description">Who do you want to add to the group?</div>
        <Select
          multi={true}
          autoFocus={true}
          options={availableUsers}
          pageSize={10}
          optionRenderer={this.renderSelectOption}
          placeholder="Add a participant to the group..."
          onChange={this.onParticipantsSelected}
          size="large"
        />
        { selectedParticipants.map((user, index) => {
          const selectedUser = users[user]
          return (
              <div key={index} className="group-participant-selected">
                <UserAvatarOption user={selectedUser} onUserDeleted={this.onGroupUserRemoved}/>
              </div>
          )
        })
        }
      </div>
    )
  }
}

export default GroupParticipantAction



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/ParticipantActions/GroupParticipantAction.js